export const fr = {
  "Rubrics": "Grilles d'évaluation",
  "New Rubric": "Nouvelle grille",
  "Create scoring rubrics for any topic, subject, or assignment": "Créez des grilles d'évaluation pour tout thème, matière ou devoir",
  "AI Draft": "Brouillon IA",
  "Start Blank": "Commencer à vide",
  "Topic / what to assess": "Thème / quoi évaluer",
  "Class (optional)": "Classe (facultatif)",
  "Title (optional)": "Titre (facultatif)",
  "Levels": "Niveaux",
  "Generate Rubric": "Générer la grille",
  "Create": "Créer",
  "Criteria": "Critères",
  "Criterion name": "Nom du critère",
  "Descriptor...": "Descripteur...",
  "Add Criterion": "Ajouter un critère",
  "Add level": "Ajouter un niveau",
  "Remove level": "Supprimer le niveau",
  "Remove": "Supprimer",
  "Score Student": "Noter un élève",
  "Save to Gradebook": "Enregistrer dans le carnet",
  "Tap cells below to score": "Touchez les cellules pour noter",
  "Select student": "Sélectionner un élève",
  "Select a rubric or create a new one": "Sélectionnez une grille ou créez-en une nouvelle",
  "No rubrics yet. Create your first one!": "Pas encore de grilles. Créez la première !",
  "Rubric created!": "Grille créée !",
  "Rubric saved": "Grille enregistrée",
  "Rubric deleted": "Grille supprimée",
  "Rubric duplicated": "Grille dupliquée",
  "Delete this rubric?": "Supprimer cette grille ?",
  "Duplicate": "Dupliquer",
  "No class": "Sans classe",
  "Rubric": "Grille",
  "Saved to gradebook": "Enregistré dans le carnet",
  "Failed to save score": "Échec de l'enregistrement de la note",
  "Select a class and student": "Sélectionnez une classe et un élève",
  "Failed to create rubric. Please try again.": "Échec de la création. Réessayez.",
  "Analyzing the topic...": "Analyse du thème...",
  "Defining criteria...": "Définition des critères...",
  "Writing level descriptors...": "Rédaction des descripteurs...",
  "Excellent": "Excellent",
  "Good": "Bien",
  "Fair": "Passable",
  "Needs Improvement": "À améliorer",
  "New Level": "Nouveau niveau",
  "Total points possible": "Points totaux possibles",
  "Loading...": "Chargement...",
  "Failed to duplicate": "Échec de la duplication",
  "Send to Google Classroom": "Envoyer vers Google Classroom",
  "Opening Google Classroom...": "Ouverture de Google Classroom...",
  "Failed to share to Classroom": "Échec du partage vers Classroom",
  "Analyzing standards...": "Analyse des normes...",
  "Writing content...": "Rédaction du contenu...",
  "Formatting sections...": "Mise en forme des sections...",
  "Finalizing...": "Finalisation...",
  "All Plans": "Tous les plans",
  "Color": "Couleur",
  "Current": "Actuel",
  "Delete": "Supprimer",
  "Delete this folder? Plans will be moved to \"Unfiled\"": "Supprimer ce dossier ? Les plans seront déplacés vers « Sans dossier »",
  "Edit": "Modifier",
  "Edit Folder": "Modifier le dossier",
  "Error creating folder": "Erreur lors de la création du dossier",
  "Error deleting folder": "Erreur lors de la suppression du dossier",
  "Error moving plan": "Erreur lors du déplacement du plan",
  "Error updating folder": "Erreur lors de la mise à jour du dossier",
  "Ex: Math 5th Grade": "Ex : Maths CM2",
  "Folder created": "Dossier créé",
  "Folder deleted": "Dossier supprimé",
  "Folder name": "Nom du dossier",
  "Folder updated": "Dossier mis à jour",
  "Folders": "Dossiers",
  "Move to folder": "Déplacer vers un dossier",
  "New Folder": "Nouveau dossier",
  "No objective defined": "Aucun objectif défini",
  "No unfiled plans": "Aucun plan sans dossier",
  "Plan moved": "Plan déplacé",
  "This folder is empty": "Ce dossier est vide",
  "Unfiled": "Sans dossier",
  "You don't have any lesson plans": "Vous n'avez aucun plan de cours",
  "Your lesson plans": "Vos plans de cours",
  "Take Attendance": "Faire l'appel",
  "You have": "Vous avez",
  "class(es) without attendance today": "classe(s) sans appel aujourd'hui",
  "Student Intervention Needed": "Intervention nécessaire auprès d'élèves",
  "student(s) showing significant struggles - consider reaching out": "élève(s) en grande difficulté - pensez à les contacter",
  "Overdue Grading": "Corrections en retard",
  "assignment(s) past due date need grading": "devoir(s) échus à corriger",
  "Plan Next Week": "Planifier la semaine prochaine",
  "class(es) don't have lessons planned for next week": "classe(s) sans leçons planifiées pour la semaine prochaine",
  "10th Grade": "Seconde (10e)",
  "11th Grade": "Première (11e)",
  "12th Grade": "Terminale (12e)",
  "1st Grade": "CP (1re)",
  "2nd Grade": "CE1 (2e)",
  "3rd Grade": "CE2 (3e)",
  "4th Grade": "CM1 (4e)",
  "5th Grade": "CM2 (5e)",
  "6th Grade": "6e",
  "7th Grade": "5e (7e)",
  "8th Grade": "4e (8e)",
  "9th Grade": "3e (9e)",
  "AI Assignment generated": "Devoir IA généré",
  "AI Assignments": "Devoirs IA",
  "AI Assistant": "Assistant IA",
  "AI Generated": "Généré par IA",
  "AI Grading": "Correction IA",
  "AI Recommendations": "Recommandations IA",
  "AI Suggestions": "Suggestions IA",
  "AI Teaching Assistant": "Assistant pédagogique IA",
  "Access Link": "Lien d'accès",
  "Access resources to help plan your lessons": "Accédez à des ressources pour planifier vos leçons",
  "Activity Ideas": "Idées d'activités",
  "Adapt": "Adapter",
  "Adapt with AI": "Adapter avec l'IA",
  "Adaptive Learning": "Apprentissage adaptatif",
  "Add": "Ajouter",
  "Add New Category": "Ajouter une catégorie",
  "Add Question": "Ajouter une question",
  "Add option": "Ajouter une option",
  "Add pair": "Ajouter une paire",
  "Add to Calendar": "Ajouter au calendrier",
  "Additional Instructions (optional)": "Instructions supplémentaires (facultatif)",
  "Additional Notes": "Notes supplémentaires",
  "Additional instructions": "Instructions supplémentaires",
  "Additional notes...": "Notes supplémentaires...",
  "All caught up!": "Tout est à jour !",
  "All semesters": "Tous les semestres",
  "All students on track!": "Tous les élèves sont sur la bonne voie !",
  "All suggestions applied": "Toutes les suggestions appliquées",
  "Analysis took too long. Please try again.": "L'analyse a pris trop de temps. Veuillez réessayer.",
  "Analyzing PDF with AI... This may take up to a minute.": "Analyse du PDF avec l'IA... Cela peut prendre jusqu'à une minute.",
  "Analyzing...": "Analyse en cours...",
  "Answer Key": "Corrigé",
  "Answer:": "Réponse :",
  "Apply All": "Tout appliquer",
  "Apply as-is": "Appliquer tel quel",
  "Apply to notes": "Appliquer aux notes",
  "Approve & Publish": "Approuver et publier",
  "Art": "Arts plastiques",
  "Ask me about planning, standards, teaching strategies...": "Posez-moi des questions sur la planification, les normes, les stratégies pédagogiques...",
  "Assessment": "Évaluation",
  "Assignment List": "Liste des devoirs",
  "Assignment created": "Devoir créé",
  "Assignment created!": "Devoir créé !",
  "Assignment created. Student link copied to clipboard.": "Devoir créé. Lien élève copié dans le presse-papiers.",
  "Assignment deleted": "Devoir supprimé",
  "Assignment name": "Nom du devoir",
  "Assignment updated": "Devoir mis à jour",
  "Assignments & Gradebook": "Devoirs et carnet de notes",
  "Assignments to Grade": "Devoirs à corriger",
  "At Risk": "À risque",
  "Attendance": "Présence",
  "Attendance Rpt": "Rapport de présence",
  "Attendance saved": "Présence enregistrée",
  "Automate your entire Sunday night prep with a single prompt": "Automatisez toute votre préparation du dimanche soir avec une seule consigne",
  "Back": "Retour",
  "Based on grades & attendance": "Basé sur les notes et la présence",
  "Bilingual": "Bilingue",
  "Both (CC + PR)": "Les deux (CC + PR)",
  "Briefly describe what makes this lesson structure successful...": "Décrivez brièvement ce qui rend cette structure de leçon efficace...",
  "Build Questions": "Créer des questions",
  "CC + PR": "CC + PR",
  "Calendar": "Calendrier",
  "Calendar Events": "Événements du calendrier",
  "Cancel": "Annuler",
  "Cannot delete category with assignments": "Impossible de supprimer une catégorie contenant des devoirs",
  "Categories": "Catégories",
  "Category": "Catégorie",
  "Category created": "Catégorie créée",
  "Category deleted": "Catégorie supprimée",
  "Category updated": "Catégorie mise à jour",
  "Chat": "Discussion",
  "Chat with AI Assistant": "Discuter avec l'assistant IA",
  "Choose File": "Choisir un fichier",
  "Class": "Classe",
  "Class created": "Classe créée",
  "Class deleted": "Classe supprimée",
  "Class updated": "Classe mise à jour",
  "Classes Today": "Cours aujourd'hui",
  "Close": "Fermer",
  "Closure": "Conclusion",
  "Column A": "Colonne A",
  "Column B": "Colonne B",
  "Complete required fields": "Remplissez les champs obligatoires",
  "Connecting to server... Retrying": "Connexion au serveur... Nouvelle tentative",
  "Content generated! Use the Save button to save it.": "Contenu généré ! Utilisez le bouton Enregistrer pour le sauvegarder.",
  "Convert to Online Test": "Convertir en test en ligne",
  "Copied!": "Copié !",
  "Copy": "Copier",
  "Copy Link": "Copier le lien",
  "Copy link": "Copier le lien",
  "Copy student link": "Copier le lien élève",
  "Core": "Tronc commun",
  "Correct answer": "Bonne réponse",
  "Create assessments with answers": "Créez des évaluations avec corrigés",
  "Create with AI": "Créer avec l'IA",
  "Created with TeacherHubPro - AI Assistant for Teachers": "Créé avec TeacherHubPro - Assistant IA pour enseignants",
  "Creative classroom activities": "Activités de classe créatives",
  "Current Categories": "Catégories actuelles",
  "Customized template applied!": "Modèle personnalisé appliqué !",
  "Dark": "Sombre",
  "Dark mode": "Mode sombre",
  "Date Range (2 Weeks)": "Période (2 semaines)",
  "Date of Test/Quiz": "Date du test/quiz",
  "Day theme...": "Thème du jour...",
  "Delete this assignment?": "Supprimer ce devoir ?",
  "Delete this prep batch?": "Supprimer cette préparation ?",
  "Delete this template?": "Supprimer ce modèle ?",
  "Deleted": "Supprimé",
  "Describe the learning goal...": "Décrivez l'objectif d'apprentissage...",
  "Describe what you need to prep and the agent will generate everything automatically": "Décrivez ce que vous devez préparer et l'agent générera tout automatiquement",
  "Describe your lesson and AI will generate a standards-based plan.": "Décrivez votre leçon et l'IA générera un plan conforme aux normes.",
  "Description": "Description",
  "Description / Instructions": "Description / Instructions",
  "Differentiation strategies": "Stratégies de différenciation",
  "Difficulty": "Difficulté",
  "Done": "Terminé",
  "Due Date (optional)": "Date limite (facultatif)",
  "Due:": "À rendre :",
  "Duration (minutes)": "Durée (minutes)",
  "E.g., Decimal multiplication": "Ex. : Multiplication des décimaux",
  "E.g., Equivalent fractions": "Ex. : Fractions équivalentes",
  "E.g., Focus on word problems...": "Ex. : Accent sur les problèmes écrits...",
  "E.g., Fractions Plan - 4th Grade": "Ex. : Plan Fractions - CM1",
  "E.g., Fractions with different denominators": "Ex. : Fractions avec dénominateurs différents",
  "E.g., Fractions, American Revolution...": "Ex. : Fractions, Révolution américaine...",
  "E.g., math, fractions, hands-on": "Ex. : maths, fractions, pratique",
  "ELA": "Français/Lettres",
  "Easy": "Facile",
  "Edit Assignment": "Modifier le devoir",
  "Edit Class": "Modifier la classe",
  "Edit Parent Email": "Modifier l'e-mail aux parents",
  "Edit class": "Modifier la classe",
  "Educational Games": "Jeux éducatifs",
  "End": "Fin",
  "English": "Anglais",
  "English/Reading": "Anglais/Lecture",
  "Enjoy your day off": "Profitez de votre journée de repos",
  "Enrichment": "Enrichissement",
  "Enter a topic": "Saisissez un sujet",
  "Enter question...": "Saisissez la question...",
  "Enter your prep request": "Saisissez votre demande de préparation",
  "Error applying template": "Erreur lors de l'application du modèle",
  "Error creating class": "Erreur lors de la création de la classe",
  "Error customizing": "Erreur de personnalisation",
  "Error deleting": "Erreur de suppression",
  "Error exporting calendar": "Erreur d'exportation du calendrier",
  "Error generating link": "Erreur de génération du lien",
  "Error generating plan": "Erreur de génération du plan",
  "Error generating suggestions": "Erreur de génération des suggestions",
  "Error generating weekly plan": "Erreur de génération du plan hebdomadaire",
  "Error loading AI assignments": "Erreur de chargement des devoirs IA",
  "Error loading template": "Erreur de chargement du modèle",
  "Error loading templates": "Erreur de chargement des modèles",
  "Error saving template": "Erreur d'enregistrement du modèle",
  "Error sending email": "Erreur d'envoi de l'e-mail",
  "Essay": "Rédaction",
  "Essay answers are graded manually": "Les rédactions sont corrigées manuellement",
  "Everything published successfully!": "Tout a été publié avec succès !",
  "Ex: Chapter 1 - Vocabulary": "Ex : Chapitre 1 - Vocabulaire",
  "Ex: English": "Ex : Anglais",
  "Ex: Greetings and Introductions": "Ex : Salutations et présentations",
  "Ex: Prep next week for Unit 3 History (Civil War), matching state curriculum standards": "Ex : Préparer la semaine prochaine pour l'Unité 3 d'Histoire (Guerre civile), selon les normes du programme",
  "Ex: Unit 1": "Ex : Unité 1",
  "Expiration (days)": "Expiration (jours)",
  "Expires:": "Expire :",
  "Failed to delete": "Échec de la suppression",
  "Failed to generate assignment": "Échec de la génération du devoir",
  "Failed to generate content. Please try again.": "Échec de la génération du contenu. Veuillez réessayer.",
  "Failed to load data": "Échec du chargement des données",
  "Failed to parse PDF": "Échec de l'analyse du PDF",
  "Failed to publish": "Échec de la publication",
  "Failed to save": "Échec de l'enregistrement",
  "Failed to start agent": "Échec du démarrage de l'agent",
  "Failed to upload file": "Échec du téléversement du fichier",
  "False": "Faux",
  "File uploaded": "Fichier téléversé",
  "Fill Blank": "Texte à trous",
  "First and last name required": "Prénom et nom requis",
  "Friday Quiz": "Quiz du vendredi",
  "From": "Du",
  "Full weekly plan generated! Review each day.": "Plan hebdomadaire complet généré ! Vérifiez chaque jour.",
  "Generate": "Générer",
  "Generate Assignment": "Générer un devoir",
  "Generate Assignment with AI": "Générer un devoir avec l'IA",
  "Generate Content": "Générer le contenu",
  "Generate Full Week": "Générer la semaine complète",
  "Generate Plan": "Générer le plan",
  "Generate Plan with AI": "Générer le plan avec l'IA",
  "Generate a structured weekly lesson plan with objectives, daily activities, and materials.": "Générez un plan de cours hebdomadaire structuré avec objectifs, activités quotidiennes et matériel.",
  "Generate a weekly plan with AI and save it as a template": "Générez un plan hebdomadaire avec l'IA et enregistrez-le comme modèle",
  "Generate complete lesson plans": "Générez des plans de cours complets",
  "Generate content and use the \"Save Content\" button to save it here": "Générez du contenu et utilisez le bouton « Enregistrer le contenu » pour le sauvegarder ici",
  "Generate materials based on National Standards, instantly.": "Générez instantanément du matériel basé sur les normes nationales.",
  "Generate practice worksheets": "Générez des fiches d'exercices",
  "Generate with AI": "Générer avec l'IA",
  "Generated Content": "Contenu généré",
  "Generated Questions": "Questions générées",
  "Generated content will appear here": "Le contenu généré apparaîtra ici",
  "Generated with AI Assistant": "Généré avec l'assistant IA",
  "Generating content...": "Génération du contenu...",
  "Generating link...": "Génération du lien...",
  "Generating week...": "Génération de la semaine...",
  "Generating...": "Génération...",
  "Generation failed.": "Échec de la génération.",
  "Generation failed. Please try again.": "Échec de la génération. Veuillez réessayer.",
  "Generation timed out": "Délai de génération dépassé",
  "Generation took too long. Please try again.": "La génération a pris trop de temps. Veuillez réessayer.",
  "Geography": "Géographie",
  "Get detailed topic summaries": "Obtenez des résumés détaillés de sujets",
  "Go to SM Aprendizaje": "Aller à SM Aprendizaje",
  "Grade": "Niveau",
  "Grade Level": "Niveau scolaire",
  "Grade Level *": "Niveau scolaire *",
  "Grade Report": "Bulletin de notes",
  "Grade Scale": "Barème de notes",
  "Gradebook": "Carnet de notes",
  "Grades": "Notes",
  "Hard": "Difficile",
  "Health": "Santé",
  "Hi! I'm your AI assistant.": "Bonjour ! Je suis votre assistant IA.",
  "High": "Élevé",
  "History": "Histoire",
  "Hook/Intro": "Accroche/Intro",
  "How do I teach fractions?": "Comment enseigner les fractions ?",
  "How to capture attention...": "Comment capter l'attention...",
  "How to close the lesson...": "Comment conclure la leçon...",
  "I can help you with lesson planning, teaching strategies, and questions about standards.": "Je peux vous aider avec la planification des cours, les stratégies pédagogiques et les questions sur les normes.",
  "Ideas for reading activities": "Idées d'activités de lecture",
  "Instructions for students...": "Instructions pour les élèves...",
  "Instructions for this question (optional)...": "Instructions pour cette question (facultatif)...",
  "Instructions:": "Instructions :",
  "Integration with other subjects": "Intégration avec d'autres matières",
  "Item": "Élément",
  "Kindergarten": "Maternelle",
  "Language": "Langue",
  "Learning Goal": "Objectif d'apprentissage",
  "Learning Objective/s": "Objectif(s) d'apprentissage",
  "Lesson Date Range": "Période de la leçon",
  "Lesson Plan": "Plan de cours",
  "Lesson Templates": "Modèles de cours",
  "Lesson Topic": "Sujet de la leçon",
  "Lessons": "Leçons",
  "Light": "Clair",
  "Light mode": "Mode clair",
  "Link copied": "Lien copié",
  "Link copied to clipboard": "Lien copié dans le presse-papiers",
  "Link copied!": "Lien copié !",
  "List of materials...": "Liste du matériel...",
  "Loading templates...": "Chargement des modèles...",
  "Low": "Faible",
  "Manage Grade Categories": "Gérer les catégories de notes",
  "Manage your classes and students": "Gérez vos classes et vos élèves",
  "Manual Assignments": "Devoirs manuels",
  "Match": "Association",
  "Match:": "Associez :",
  "Matching": "Association",
  "Materials Needed": "Matériel nécessaire",
  "Math": "Maths",
  "Mathematics": "Mathématiques",
  "Medium": "Moyen",
  "Multiple Choice": "Choix multiple",
  "Music": "Musique",
  "My Prep Batches": "Mes préparations",
  "My Templates": "Mes modèles",
  "Name (English)": "Nom (anglais)",
  "Name (Spanish)": "Nom (espagnol)",
  "Name is required": "Le nom est requis",
  "New Lesson": "Nouvelle leçon",
  "New Weekly Prep": "Nouvelle préparation hebdomadaire",
  "New chat": "Nouvelle discussion",
  "No assignments": "Aucun devoir",
  "No assignments created": "Aucun devoir créé",
  "No categories. Create one to get started.": "Aucune catégorie. Créez-en une pour commencer.",
  "No classes today": "Pas de cours aujourd'hui",
  "No classes yet": "Pas encore de classes",
  "No content to save": "Aucun contenu à enregistrer",
  "No email generated": "Aucun e-mail généré",
  "No pending assignments": "Aucun devoir en attente",
  "No prep batches yet": "Pas encore de préparations",
  "No questions found in the PDF": "Aucune question trouvée dans le PDF",
  "No questions to print": "Aucune question à imprimer",
  "No quiz generated": "Aucun quiz généré",
  "No risk alerts at this time": "Aucune alerte de risque pour le moment",
  "No saved plans yet": "Pas encore de plans enregistrés",
  "No saved templates": "Aucun modèle enregistré",
  "No students": "Aucun élève",
  "No students in this class": "Aucun élève dans cette classe",
  "No students yet": "Pas encore d'élèves",
  "No suggestions to save": "Aucune suggestion à enregistrer",
  "Number of Questions": "Nombre de questions",
  "Number of questions": "Nombre de questions",
  "Open Portal": "Ouvrir le portail",
  "Option": "Option",
  "Optional: add specific details...": "Facultatif : ajoutez des détails spécifiques...",
  "Or adapt for your specific topic:": "Ou adaptez à votre sujet spécifique :",
  "Or create a new prep batch above": "Ou créez une nouvelle préparation ci-dessus",
  "Or customize for new topic:": "Ou personnalisez pour un nouveau sujet :",
  "Original topic:": "Sujet original :",
  "Other": "Autre",
  "Overdue": "En retard",
  "Parent Email": "E-mail aux parents",
  "Parent Portal": "Portail parents",
  "Period": "Période",
  "Physical Education": "Éducation physique",
  "Plan Title": "Titre du plan",
  "Plan Type": "Type de plan",
  "Plan created": "Plan créé",
  "Plan deleted": "Plan supprimé",
  "Plan duplicated": "Plan dupliqué",
  "Plan generated! Review and edit as needed.": "Plan généré ! Vérifiez et modifiez si nécessaire.",
  "Plan saved!": "Plan enregistré !",
  "Plan updated": "Plan mis à jour",
  "Play to Learn": "Jouer pour apprendre",
  "Please add an objective or topic first to generate suggestions": "Veuillez d'abord ajouter un objectif ou un sujet pour générer des suggestions",
  "Please add an objective or topic first to generate the weekly plan": "Veuillez d'abord ajouter un objectif ou un sujet pour générer le plan hebdomadaire",
  "Please allow pop-ups to print": "Veuillez autoriser les fenêtres pop-up pour imprimer",
  "Please enter a new topic": "Veuillez saisir un nouveau sujet",
  "Please fill in all fields": "Veuillez remplir tous les champs",
  "Please fill in all required fields": "Veuillez remplir tous les champs obligatoires",
  "Please respond in English.": "Please respond in French.",
  "Prep Agent": "Agent de préparation",
  "Prep agent started": "Agent de préparation démarré",
  "Prep failed": "Échec de la préparation",
  "Presentations": "Présentations",
  "Pricing": "Tarifs",
  "Print": "Imprimer",
  "Print / PDF": "Imprimer / PDF",
  "Print / Save PDF": "Imprimer / Enregistrer en PDF",
  "Published": "Publié",
  "Question Types": "Types de questions",
  "Quick Actions": "Actions rapides",
  "Quiz/Assessment": "Quiz/Évaluation",
  "Quiz/Test": "Quiz/Test",
  "Ready for review": "Prêt à réviser",
  "Regenerate": "Régénérer",
  "Report Cards": "Bulletins scolaires",
  "Save": "Enregistrer",
  "Save & Get Student Link": "Enregistrer et obtenir le lien élève",
  "Save Changes": "Enregistrer les modifications",
  "Save Content": "Enregistrer le contenu",
  "Save Template": "Enregistrer le modèle",
  "Save as Template": "Enregistrer comme modèle",
  "Save this plan to reuse with different topics": "Enregistrez ce plan pour le réutiliser avec d'autres sujets",
  "Saved": "Enregistré",
  "Saved Lesson Plans": "Plans de cours enregistrés",
  "Saved Content": "Contenu enregistré",
  "ESL Support": "Soutien ESL",
  "Rubric adapted for English learners (WIDA + PR standards)": "Grille adaptée aux apprenants d'anglais (normes WIDA + PR)",
  "Generate ESL-level material for English learners (WIDA + PR standards)": "Génère du matériel de niveau ESL pour les apprenants d'anglais (normes WIDA + PR)",
  "Saved on": "Enregistré le",
  "Schedule will appear in your Command Center": "L'horaire apparaîtra dans votre centre de commande",
  "Science": "Sciences",
  "Select Tool": "Choisir un outil",
  "Select a category": "Sélectionnez une catégorie",
  "Select a class": "Sélectionnez une classe",
  "Select a class to view its students": "Sélectionnez une classe pour voir ses élèves",
  "Select a prep batch to view details": "Sélectionnez une préparation pour voir les détails",
  "Select class": "Sélectionner la classe",
  "Select...": "Sélectionner...",
  "Semester": "Semestre",
  "Send Email": "Envoyer l'e-mail",
  "Send via Email": "Envoyer par e-mail",
  "Sending...": "Envoi...",
  "Share this link with the student's parents. The portal is read-only.": "Partagez ce lien avec les parents de l'élève. Le portail est en lecture seule.",
  "Short Answer": "Réponse courte",
  "Skill...": "Compétence...",
  "Slides": "Diapositives",
  "Social Studies": "Sciences sociales",
  "Spanish": "Espagnol",
  "Specify other activity...": "Précisez une autre activité...",
  "Specify other material...": "Précisez un autre matériel...",
  "Standards": "Normes",
  "Standards Framework": "Cadre de normes",
  "Start": "Début",
  "Start Prep Agent": "Démarrer l'agent de préparation",
  "Starter": "De base",
  "Starter Templates": "Modèles de base",
  "Story title": "Titre de l'histoire",
  "Student": "Élève",
  "Student PDF": "PDF élève",
  "Student Progress": "Progrès des élèves",
  "Student added": "Élève ajouté",
  "Student deleted": "Élève supprimé",
  "Student updated": "Élève mis à jour",
  "Students at Risk": "Élèves à risque",
  "Sub Packet": "Dossier de remplacement",
  "Subject": "Matière",
  "Subject *": "Matière *",
  "Suggest activities": "Suggérer des activités",
  "Suggestions applied to notes": "Suggestions appliquées aux notes",
  "Tags (comma separated)": "Étiquettes (séparées par des virgules)",
  "Take": "Passer",
  "Taxonomy Levels (Webb 2005)": "Niveaux taxonomiques (Webb 2005)",
  "Teacher": "Enseignant",
  "Teacher Name": "Nom de l'enseignant",
  "Teacher name": "Nom de l'enseignant",
  "Technology": "Technologie",
  "Template deleted": "Modèle supprimé",
  "Template name *": "Nom du modèle *",
  "Template saved!": "Modèle enregistré !",
  "Templates": "Modèles",
  "This will delete the class and all its students.": "Cela supprimera la classe et tous ses élèves.",
  "To": "Au",
  "To Grade": "À corriger",
  "Today's Schedule": "Horaire du jour",
  "Tools": "Outils",
  "Topic": "Sujet",
  "Topic *": "Sujet *",
  "Topic Summary": "Résumé du sujet",
  "Topic:": "Sujet :",
  "Total Weight": "Poids total",
  "Tour": "Visite guidée",
  "True": "Vrai",
  "True/False": "Vrai/Faux",
  "Type your question...": "Tapez votre question...",
  "Upcoming Lessons": "Leçons à venir",
  "Update Assignment": "Mettre à jour le devoir",
  "Upload File": "Téléverser un fichier",
  "Upload a test or document": "Téléversez un test ou un document",
  "Uploading...": "Téléversement...",
  "Use proven templates or save your own successful plans": "Utilisez des modèles éprouvés ou enregistrez vos propres plans réussis",
  "Use this template": "Utiliser ce modèle",
  "View": "Voir",
  "View All": "Tout voir",
  "View Assignments": "Voir les devoirs",
  "View starter templates": "Voir les modèles de base",
  "Week 1": "Semaine 1",
  "Week 1 - From": "Semaine 1 - Du",
  "Week 1 - To": "Semaine 1 - Au",
  "Week 2": "Semaine 2",
  "Week 2 - From": "Semaine 2 - Du",
  "Week 2 - To": "Semaine 2 - Au",
  "Week Starts": "Début de semaine",
  "Week of": "Semaine du",
  "Weekly Prep Agent": "Agent de préparation hebdomadaire",
  "Weekly prep is ready!": "La préparation hebdomadaire est prête !",
  "Welcome": "Bienvenue",
  "What does CCSS.MATH.4.NF say?": "Que dit CCSS.MATH.4.NF ?",
  "Will save:": "Sera enregistré :",
  "Working on:": "En cours :",
  "Worksheet": "Fiche d'exercices",
  "Worksheets": "Fiches d'exercices",
  "Write the learning objectives...": "Rédigez les objectifs d'apprentissage...",
  "You need an active subscription": "Vous avez besoin d'un abonnement actif",
  "You need an active subscription to use the AI assistant": "Vous avez besoin d'un abonnement actif pour utiliser l'assistant IA",
  "Your Request": "Votre demande",
  "Your digital classroom": "Votre classe numérique",
  "Your saved lesson plans for easy access": "Vos plans de cours enregistrés à portée de main",
  "assignments": "devoirs",
  "classes scheduled": "cours prévus",
  "days": "jours",
  "days of activities": "jours d'activités",
  "en-US": "fr-FR",
  "graded": "corrigés",
  "of total": "du total",
  "points": "points",
  "questions": "questions",
  "ready": "prêt",
  "students": "élèves",
  "submissions": "soumissions",
  "submissions pending": "soumissions en attente",
  "used": "utilisé",
  "📅 Calendar file downloaded. Open it to add to Google Calendar, Outlook, or Apple Calendar.": "📅 Fichier de calendrier téléchargé. Ouvrez-le pour l'ajouter à Google Calendar, Outlook ou Apple Calendar.",
  "📅 Schedule (Optional)": "📅 Horaire (facultatif)",
  "📅 Weekly Plan (2 Weeks)": "📅 Plan hebdomadaire (2 semaines)",
  "📗 Week 2": "📗 Semaine 2",
  "📘 Week 1": "📘 Semaine 1",
  "🗣️ Conversational English": "🗣️ Anglais conversationnel",
  "🗣️ Conversational English Plan Details": "🗣️ Détails du plan d'anglais conversationnel"
};
